import React from "react";
import { Rate  } from 'antd';

function KoRating(props) {
  console.log('props', props);
  return (
    <Rate
      {...props}
      style={{ width: '100%' }}
    />
  );
}

export  {KoRating, Rate};